import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ({ t }) {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#f0ebe1]/60"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <p className="text-overline">{t.faq.overline}</p>
          <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl mt-5 text-[#1a2421]">
            {t.faq.title}
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-2xl px-6 border border-[#2c4a3b]/8 [&[data-state=open]]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="font-serif text-xl md:text-2xl text-[#1a2421] hover:no-underline py-6">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5c6b61] leading-relaxed text-base pb-6 pr-8">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
